module.exports = "<div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/routes/bookings/booking/goldupgrade/goldupgrade.html
// module id = 134
// module chunks = 0